"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var get_product_attributes_thunk_1 = require("../../../../../../../../../reducers/slices/products/product_attribute/thunks/get_product_attributes_thunk");
var useRenderCellEditViews_1 = require("../../../../hooks/useRenderCellEditViews");
var PimBulkEditAttributes = function (_a) {
    var handleSetModifiedProducts = _a.handleSetModifiedProducts, selectedTableCells = _a.selectedTableCells;
    var dispatch = (0, react_redux_1.useDispatch)();
    var renderCellVEditViews = (0, useRenderCellEditViews_1.useRenderCellEditViews)().renderCellVEditViews;
    var _b = (0, react_2.useState)({ attributes: {} }), attributesState = _b[0], setAttributesState = _b[1];
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeState; }), productAttributes = _c.productAttributes, pagination = _c.pagination, loading = _c.loading;
    var client_token = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).client_token;
    var _ids = (0, react_2.useMemo)(function () { return Array.from(selectedTableCells); }, [selectedTableCells]);
    var _d = (0, react_2.useState)([
        {
            _id: 0,
            price: 0,
            category: [],
            promotion_price: 0,
            on_promotion: false,
        },
    ]), emptyFieldValuePair = _d[0], setEmptyFieldValuePair = _d[1];
    var getProductAttributes = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var sort_by = _a.sort_by, order_by = _a.order_by, query = __rest(_a, ["sort_by", "order_by"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_product_attributes_thunk_1.get_product_attributes_thunk)(query))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
    (0, react_2.useEffect)(function () {
        if (client_token && !loading) {
            getProductAttributes(__assign({}, pagination));
        }
    }, [client_token]);
    var handleAttributeChange = function (attribute, value) {
        setAttributesState(function (prevState) {
            var _a;
            return ({
                attributes: __assign(__assign({}, prevState.attributes), (_a = {}, _a[attribute._id] = __assign(__assign(__assign({}, prevState.attributes[attribute._id]), attribute), { default_value: value }), _a)),
            });
        });
        var attributesArray = Object.values(attributesState["attributes"]);
        _ids.forEach(function (id) {
            handleSetModifiedProducts({ key: "attributes", value: attributesArray, id: id });
        });
    };
    var renderInputField = function (attribute) {
        var _a, _b, _c, _d;
        switch (attribute.type) {
            case "TEXT":
                return ((0, jsx_runtime_1.jsx)(react_1.Input, { type: "text", label: attribute.name, value: ((_a = attributesState.attributes[attribute._id]) === null || _a === void 0 ? void 0 : _a.default_value) || "", onChange: function (e) { return handleAttributeChange(attribute, e.target.value); }, placeholder: "Enter ".concat(attribute.name) }));
            case "NUMBER":
                return ((0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", value: ((_b = attributesState.attributes[attribute._id]) === null || _b === void 0 ? void 0 : _b.default_value) || "", onChange: function (e) { return handleAttributeChange(attribute, e.target.value); }, placeholder: "Enter ".concat(attribute.name) }));
            case "BOOLEAN":
                return ((0, jsx_runtime_1.jsx)(react_1.Checkbox, __assign({ isSelected: ((_c = attributesState.attributes[attribute._id]) === null || _c === void 0 ? void 0 : _c.default_value) || false, onChange: function (e) { return handleAttributeChange(attribute, e.target.checked); } }, { children: attribute.name })));
            case "LIST":
                return ((0, jsx_runtime_1.jsx)(react_1.Select, __assign({ value: ((_d = attributesState.attributes[attribute._id]) === null || _d === void 0 ? void 0 : _d.default_value) || "", onChange: function (value) { return handleAttributeChange(attribute, value); } }, { children: attribute.options.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option }, { children: option }), option)); }) })));
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col w-full" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-between gap-4" }, { children: emptyFieldValuePair.map(function (record, i) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-wrap justify-center gap-4 w-full" }, { children: [Object.keys(record).map(function (key) {
                        var cellView = renderCellVEditViews(record[key], record, function (modifiedRecord) {
                            var key = modifiedRecord.key, value = modifiedRecord.value;
                            setEmptyFieldValuePair(function (prev) { return prev.map(function (item, index) {
                                var _a;
                                return (index === i ? __assign(__assign({}, item), (_a = {}, _a[key] = value, _a)) : item);
                            }); });
                            _ids.forEach(function (id) {
                                handleSetModifiedProducts({ key: key, value: value, id: id });
                            });
                        }).find(function (cValue) { return key === (cValue === null || cValue === void 0 ? void 0 : cValue.key); });
                        return cellView ? (0, jsx_runtime_1.jsx)("div", { children: cellView.content }, "".concat(i, "-").concat(key)) : null;
                    }), productAttributes.map(function (attribute) { return ((0, jsx_runtime_1.jsx)("div", { children: renderInputField(attribute) }, attribute._id)); })] }), "record-".concat(i))); }) })) })));
};
exports.default = PimBulkEditAttributes;
